module.exports = "input {\n\tvertical-align: baseline;\n\tcolor: inherit;\n\tfont-size: inherit;\n\tdisplay: inline-block;\n\tborder: none;\n\twidth: 98px;\n\tbackground-color: transparent;\n\tpadding: 0;\n\tmargin: 0;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./app/steps/phonecall/phone-input/phone-input.css
 ** module id = 944
 ** module chunks = 1
 **/